export default {
  eSeries6: 2,
  eSeries12: 2,
  eSeries24: 2,
  eSeries48: 3,
  eSeries96: 3,
};
